{
  "enum": {
    "IxfWatchlistV1ElectronicContactType": {
      "EMAIL_ADDRESS": "Email Address",
      "UNSPECIFIED": "Unspecified",
      "WEB_SITE_ADDRESS": "Web Site Address"
    },
    "IxfWatchlistV1EntryTypeEnum": {
      "INDIVIDUAL": "Individual",
      "ORGANIZATION": "Organization",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfWatchlistV1Fincen314EntryStatus": {
      "CREATED": "Created",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfWatchlistV1Fincen314FileStatus": {
      "CREATED": "Created",
      "DONE": "Done",
      "FAILED": "Failed",
      "INGESTING": "Ingesting",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfWatchlistV1Fincen314MatchStatus": {
      "CLOSED": "Closed",
      "OPENED": "Opened",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfWatchlistV1IdentificationType": {
      "ALIEN_REGISTRATION": "Alien Registration",
      "DRIVERS_LICENSE": "Drivers License",
      "EIN": "EIN",
      "PASSPORT": "Passport",
      "SSN_ITIN": "SSN ITIN",
      "TIN": "Tin",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfWatchlistV1ListType": {
      "FINCEN": "FinCEN",
      "OFAC": "OFAC",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfWatchlistV1OfacFileStatus": {
      "CREATED": "Created",
      "DONE": "Done",
      "FAILED": "Failed",
      "INGESTING": "Ingesting",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfWatchlistV1OfacMatchStatus": {
      "CLOSED": "Closed",
      "OPENED": "Opened",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfWatchlistV1OfacSdnStatus": {
      "CREATED": "Created",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfWatchlistV1OpenedBy": {
      "MANUAL_SCREEN": "Manual Screen",
      "PROFILE_CREATED": "Profile Created",
      "PROFILE_UPDATED": "Profile Updated",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListFilterableFields": {
      "data": {
        "spec": {
          "individual": {
            "electronicContacts": {
              "type": "Electronic Contacts Type"
            },
            "identifications": {
              "type": "Identifications Type"
            }
          },
          "organization": {
            "electronicContacts": {
              "type": "Electronic Contacts Type"
            },
            "identifications": {
              "type": "Identifications Type"
            }
          }
        },
        "type": "Data Type"
      },
      "fincen314EntryId": "Fincen314 Entry ID",
      "fincen314FileId": "Fincen314 File ID",
      "status": "Status"
    },
    "IxfWatchlistV1Fincen314FileQueryServiceFincen314FileListFilterableFields": {
      "fincen314FileId": "FinCEN File",
      "status": "Status"
    },
    "IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListFilterableFields": {
      "data": {
        "spec": {
          "matchValues": {
            "electronicContact": {
              "type": "Electronic Contact Type"
            },
            "identification": {
              "type": "Identification Type"
            }
          }
        }
      },
      "fincen314MatchId": "Fincen314 Match ID",
      "profileId": "Profile ID",
      "status": "Status"
    },
    "IxfWatchlistV1OfacFileQueryServiceOfacFileListFilterableFields": {
      "ofacFileId": "OFAC File",
      "status": "Status"
    },
    "IxfWatchlistV1OfacMatchQueryServiceOfacMatchListFilterableFields": {
      "data": {
        "spec": {
          "matchValues": {
            "electronicContact": {
              "type": "Data Spec Match Values Electronic Contact Type"
            },
            "identification": {
              "type": "Data Spec Match Values Identification Type"
            }
          }
        }
      },
      "ofacMatchId": "OFAC Match ID",
      "profileId": "Profile ID",
      "status": "Status"
    },
    "IxfWatchlistV1OfacSdnQueryServiceOfacSdnListFilterableFields": {
      "ofacFileId": "OFAC File",
      "ofacSdnId": "OFAC SDN",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxfWatchlistV1Fincen314EntryEventType": {
      "created": "Created"
    },
    "IxfWatchlistV1Fincen314FileEventType": {
      "completed": "Completed",
      "errored": "Errored",
      "ingest": "Ingest",
      "process": "Process",
      "uploaded": "Uploaded"
    },
    "IxfWatchlistV1Fincen314MatchEventType": {
      "close": "Close",
      "open": "Open"
    },
    "IxfWatchlistV1OfacFileEventType": {
      "completed": "Completed",
      "created": "Created",
      "errored": "Errored",
      "ingest": "Ingest",
      "process": "Process",
      "uploaded": "Uploaded"
    },
    "IxfWatchlistV1OfacMatchEventType": {
      "close": "Close",
      "open": "Open"
    },
    "IxfWatchlistV1OfacSdnEventType": {
      "created": "Created"
    },
    "IxfWatchlistV1SdnType": {
      "individual": "Individual",
      "organization": "Organization"
    }
  },
  "searchEnum": {
    "IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListSearchableFields": {
      "data": {
        "spec": {
          "individual": {
            "aliases": {
              "firstName": "Aliase First Name",
              "lastName": "Aliase Last Name",
              "middleName": "Aliase Middle Name",
              "suffix": "Aliase Suffix"
            },
            "electronicContacts": {
              "value": "Electronic Contact"
            },
            "identifications": {
              "id": "Identification ID"
            },
            "name": {
              "firstName": "First Name",
              "lastName": "Last Name",
              "middleName": "Middle Name",
              "suffix": "Suffix"
            }
          },
          "organization": {
            "dba": {
              "dbaName": "Dba Names"
            },
            "electronicContacts": {
              "value": "Electronic Contacts"
            },
            "identifications": {
              "id": "Identifications"
            },
            "name": {
              "businessName": "Business Name"
            }
          }
        },
        "trackingNumber": "Tracking Number"
      }
    },
    "IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListSearchableFields": {
      "data": {
        "spec": {
          "matchValues": {
            "electronicContact": {
              "value": "Electronic Contact"
            },
            "identification": {
              "id": "Identification ID"
            },
            "individualName": {
              "firstName": "First Name",
              "lastName": "Last Name",
              "middleName": "Middle Name",
              "suffix": "Suffix"
            },
            "organizationName": {
              "businessName": "Business Name"
            }
          }
        }
      }
    },
    "IxfWatchlistV1OfacMatchQueryServiceOfacMatchListSearchableFields": {
      "data": {
        "spec": {
          "matchValues": {
            "electronicContact": {
              "value": "Data Spec Match Values Electronic Contact Value"
            },
            "identification": {
              "id": "Data Spec Match Values Identification ID"
            },
            "individualName": {
              "firstName": "Data Spec Match Values Individual Name First Name",
              "lastName": "Data Spec Match Values Individual Name Last Name",
              "middleName": "Data Spec Match Values Individual Name Middle Name",
              "suffix": "Data Spec Match Values Individual Name Suffix"
            },
            "organizationName": {
              "businessName": "Data Spec Match Values Organization Name Business Name"
            }
          }
        }
      }
    },
    "IxfWatchlistV1OfacSdnQueryServiceOfacSdnListSearchableFields": {
      "data": {
        "spec": {
          "sdn": {
            "individual": {
              "akas": {
                "firstName": "AKA First Name",
                "lastName": "AKA Last Name"
              },
              "firstName": "First Name",
              "ids": {
                "idNumber": "ID Number"
              },
              "lastName": "Last Name"
            },
            "organization": {
              "akas": {
                "name": "AKA Name"
              },
              "ids": {
                "idNumber": "ID Number"
              },
              "name": "Organization Name"
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxfWatchlistV1Fincen314EntryQueryServiceFincen314EntryListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxfWatchlistV1Fincen314FileQueryServiceFincen314FileListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxfWatchlistV1Fincen314MatchQueryServiceFincen314MatchListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxfWatchlistV1OfacFileQueryServiceOfacFileListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxfWatchlistV1OfacMatchQueryServiceOfacMatchListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxfWatchlistV1OfacSdnQueryServiceOfacSdnListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}